import type { FeatureCategory, FeatureView, GetLabel } from '../types/feature';
import Option from './Option';
import Search from './Search';
import Select from './Select';

type ControlsProps = {
	categories: Record<string, FeatureCategory>;
	clearSearchField: () => void;
	setSearchValue: (value: string) => void;
	setCategoryFilterTerm: (slug: string) => void;
	handleViewChange: () => void;
	getLabel: GetLabel;
	searchValue: string;
	categoryFilterTerm: string;
	view: FeatureView;
	isFiltered: boolean;
};

export default function Controls({
	categories,
	clearSearchField,
	setSearchValue,
	setCategoryFilterTerm,
	handleViewChange,
	getLabel,
	searchValue,
	categoryFilterTerm,
	view,
	isFiltered,
}: ControlsProps) {
	return (
		<div className="feature__controls">
			<Option getLabel={getLabel} view={view} handleChange={handleViewChange} />
			{!isFiltered && Object.keys(categories).length ? (
				<Select
					categories={categories}
					value={categoryFilterTerm}
					setValue={setCategoryFilterTerm}
					searchValue={searchValue}
					clearSearchField={clearSearchField}
				/>
			) : null}
			<Search searchValue={searchValue} setSearchValue={setSearchValue} getLabel={getLabel} />
		</div>
	);
}
